<template>
  <div id="LandingQueues" class="row" v-if="Vendor">
    <div v-if="Vendor.queues.length == 1">{{ checkQueuesLength() }}</div>
    <div
      class="queue row w-100"
      v-for="queue in Vendor.queues"
      :key="'queue' + queue.id"
      @click="getQueueData(queue)"
      :class="{
        'queue-selected': selected_queue && selected_queue.id == queue.id,
      }"
    >
      <div class="col-md-11 left">
        <b class="name">{{ queue.title }}</b>
        <div class="infos">
          <div class="info">
            <font-awesome-icon class="icon" icon="clock" />
            {{ queue.time_to_wait }}
          </div>
          <div class="info ml-5">
            <font-awesome-icon class="icon" icon="user" />
            {{ queue.totalWaiting }} {{ $t("Waiting") }}
          </div>
        </div>
      </div>
      <div class="col-md-1 right text-center">
        <img
          class="icon"
          :src="'/Queue-Icon ' + queue.iconImgNumber + '.svg'"
          alt=""
        />
      </div>
    </div>

    <div class="services" v-if="selected_queue">
      <div v-if="timeIsBetween">
        <div class="search">
          <input
            type="search"
            v-model="searchQuery"
            :placeholder="$t('FindYourService')"
          />
          <button class="btn">
            <font-awesome-icon class="icon" icon="search" />
          </button>
        </div>
        <div class="section-loader" v-if="loading">
          <img src="/loader-circle.gif" alt="" style="width: 30px" />
        </div>
        <div class="section-loader" v-if="spanSelectQueue">
          <span>Please select a Queue</span>
        </div>
        <!-- MAIN MARKUP-->

        <div
          v-for="(service, index) in filteredAndSortedServices"
          :key="'queueService' + service.id"
        >
          <div style="display: flex; justify-content: space-between">
            <label :for="'queue_service' + service.id" class="checkbox">
              {{ service.title }}
              <input
                @click="getQuantityServices(index, service.id)"
                :id="'queue_service' + service.id"
                name="checkbox-group"
                type="checkbox"
              />
              <span class="checkbox__mark">
                <svg
                  width="25"
                  height="18"
                  viewBox="0 0 25 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.13449 12.7269L22.2809 0L25 2.64085L9.13449 18L0 9.15702L2.71912 6.51624L9.13449 12.7269Z"
                    fill="#000000"
                  />
                </svg>
              </span>
            </label>
            <div :class="'plus' + index" style="display: none; margin: auto">
              <div
                v-for="seleted_serv in selected_services"
                :key="'A' + seleted_serv.id"
              >
                <div
                  v-if="seleted_serv.id === service.id"
                  style="display: flex"
                >
                  <button
                    @click="seleted_serv.qte > 1 ? (seleted_serv.qte -= 1) : ''"
                    class="buttonQte"
                  >
                    -
                  </button>
                  <div style="font-family: sans-serif">
                    {{ seleted_serv.qte }}
                  </div>
                  <button
                    @click="seleted_serv.qte < 9 ? (seleted_serv.qte += 1) : ''"
                    class="buttonQte"
                  >
                    +
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="space-under"></div>
      </div>
    </div>

    <div class="buttons yaraab">
      <button class="button mr-2" @click="goBack()">
        {{ $t("Return") }}
      </button>
      <button
        class="button button-filled ml-2"
        @click="joinQueue()"
        v-if="selected_queue && selected_services.length && queueEnabled"
      >
        {{ $t("JoinQueue") }}
      </button>
      <button
        class="button button-filled ml-2"
        v-else
        style="cursor: not-allowed; opacity: 0.7"
      >
        {{ $t("JoinQueue") }}
      </button>
    </div>
    <Modal
      :active="modal.active"
      :type="modal.type"
      :title="modal.title"
      :hint="modal.hint"
      :message="modal.message"
      :confirmationButton="modal.confirmationButton"
      @confirm="ModalConfirmed"
    />
    <Modal
      :active="already_have_ticket_modal.active"
      :type="already_have_ticket_modal.type"
      :title="already_have_ticket_modal.title"
      :hint="already_have_ticket_modal.hint"
      :message="already_have_ticket_modal.message"
      :confirmationButton="already_have_ticket_modal.confirmationButton"
      @confirm="AlreadyHaveTicketModalConfirmed"
    />
    <Modal
      :active="danger_modal.active"
      :type="danger_modal.type"
      :title="danger_modal.title"
      :hint="danger_modal.hint"
      :message="danger_modal.message"
      :confirmationButton="danger_modal.confirmationButton"
      @confirm="DangerModalConfirmed"
    />
  </div>
</template>

<script>
import $ from "jquery";
import Agency from "../components/Agency.vue";
import { queueService } from "/src/_services";
import moment from "moment";
import Modal from "../modals/Popup.vue";
var days = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
export default {
  data: () => ({
    queueSelectedCss: {
      slot: "",
    },
    spanSelectQueue: true,
    searchQuery: "",
    loading: false,
    active_tab: "about",
    selected_queue: null,
    selected_services: [],
    qte: 1,
    queue_services: [],
    queue_workingDay: null,
    timeIsBetween: null,
    new_ticket: null,
    has_ticket: true,

    modal: {
      active: false,
      type: "success",
      title: "Ticket pris avec succès",
      hint: "",
      message:
        "Nous vous avons envoyé un SMS où vous pouvez suivre votre billet via votre téléphone en temps réel, Merci.",
      confirmationButton: "Visiter mon ticket",
    },
    already_have_ticket_modal: {
      active: false,
      type: "danger",
      title: "Erreur est survenue",
      hint: "Vous avez déja une ticket",
      message:
        "Vous avez déjà un ticket réservé dans cette file d'attente, veuillez cliquer ci-dessous pour voir votre ticket.",
      confirmationButton: "Visiter mon ticket",
    },
    danger_modal: {
      active: false,
      type: "danger",
      title: "Ouups",
      hint: "Une erreur s'est produite",
      message:
        "Une erreur s'est produite, veuillez réessayer plus tard ou contactez-nous",
      confirmationButton: "Fermer",
    },
    queueEnabled: true
  }),
  components: {
    Agency,
    Modal,
  },
  props: {
    Vendor: Object,
  },
  computed: {
    filteredAndSortedServices() {
      // function to compare names
      function compare(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      }

      return this.queue_services
        .filter((user) => {
          return user.title
            .toLowerCase()
            .includes(this.searchQuery.toLowerCase());
        })
        .sort(compare);
    },
  },
  mounted() {
    this.modal.title = this.$t("TicketBookedSuccessffullyTitle");
    this.modal.message = this.$t("TicketBookedSuccessffullyMessage");
    this.modal.confirmationButton = this.$t("TicketBookedSuccessffullyButton");

    this.danger_modal.title = this.$t("TicketBookFailedTitle");
    this.danger_modal.hint = this.$t("TicketBookFailedHint");
    this.danger_modal.message = this.$t("TicketBookFailedMessage");
    this.danger_modal.confirmationButton = this.$t("TicketBookFailedButton");

    this.already_have_ticket_modal.title = this.$t(
      "AlreadyHaveTicketBookFailedTitle"
    );
    this.already_have_ticket_modal.hint = this.$t(
      "AlreadyHaveTicketBookFailedHint"
    );
    this.already_have_ticket_modal.message = this.$t(
      "AlreadyHaveTicketBookFailedMessage"
    );
    this.already_have_ticket_modal.confirmationButton = this.$t(
      "AlreadyHaveTicketBookFailedButton"
    );

  },
  methods: {
    getQuantityServices(index, service_id) {
      let obj = {
        index: index,
        id: service_id,
        qte: 1,
      };
      let indexExists = this.selected_services.findIndex(
        (o) => o.id === obj.id
      );
      if (indexExists === -1) {
        this.selected_services.push(obj);
      } else {
        this.selected_services.splice(indexExists, 1);
      }
      $(".plus" + index).show();
    },
    getQueueData(queue) {
      this.selected_queue = queue;
      this.queueSelectedCss = queue;
      this.spanSelectQueue = false;
      this.selected_services = [];
      this.searchQuery = "";
      $("#LandingQueues [class^='plus']").hide();
      this.loading = true;
      queueService
        .getQueueById(queue.id)
        .then(
          function (data) {
            //check if queue is open
            let today = days[new Date().getDay()];
            let timeNow = moment().format("HH:mm:ss");
            this.queue_workingDay = data.working_days.find(
              (o) => o.day === today
            );
            if (
              timeNow >= this.queue_workingDay.start_time &&
              timeNow <= this.queue_workingDay.end_time
            ) {
              this.timeIsBetween = true;
            } else {
              this.timeIsBetween = false;
            }
            if (this.timeIsBetween) {
              this.queue_services = data.services;
            } else {
              this.queue_services = [];
            }
          }.bind(this)
        )
        .finally(
          function () {
            this.loading = false;
          }.bind(this)
        );
    },
    DangerModalConfirmed() {
      this.danger_modal.active = false;
    },
    AlreadyHaveTicketModalConfirmed() {
      window.location.href = "/t/" + this.new_ticket.unique_id;
    },
    ModalConfirmed() {
      window.location.href = "/";
    },
    getTicketUniqueId(data) {
      if (!data) return null;
      if (data.ticket && data.ticket.unique_id) return data.ticket.unique_id;
      if (data.customer && data.customer.unique_id) return data.customer.unique_id;
      if (data.data && data.data.ticket && data.data.ticket.unique_id) {
        return data.data.ticket.unique_id;
      }
      if (data.data && data.data.unique_id) return data.data.unique_id;
      if (data.unique_id) return data.unique_id;
      return null;
    },
    matchesCurrentBusiness(ticket) {
      if (!ticket || !ticket.business_summary) return false;
      return (
        ticket.business_summary.organization_id == this.Config.organization_id ||
        !this.Config.organization_id ||
        this.Config.organization_id === "" ||
        ticket.business_summary.id == this.Config.default_business_id
      );
    },
    goToTicket(uniqueId) {
      if (!uniqueId) return false;
      window.location.href = "/t/" + uniqueId;
      return true;
    },
    redirectFromConfirmedTickets() {
      queueService
        .getConfirmed(this.Config.organization_id || "45")
        .then(
          function (data) {
            let already_has_ticket = false;
            const tickets = ((data.tickets && data.tickets.data) || []).filter(
              function (obj) {
                return this.matchesCurrentBusiness(obj);
              }.bind(this)
            );

            tickets.forEach(
              function (obj) {
                var duration = moment.duration(
                  moment(new Date()).diff(
                    moment(String(obj.checkinDate + " " + obj.checkinTime))
                  )
                );
                var minutes = duration.asMinutes();

                if (minutes > 2 && !already_has_ticket) {
                  already_has_ticket = obj.queue_line_id == this.selected_queue.id;
                  if (already_has_ticket) {
                    this.new_ticket = obj;
                  }
                }
              }.bind(this)
            );

            if (already_has_ticket) {
              this.already_have_ticket_modal.active = true;
              return;
            }

            const queueTickets = tickets.filter(
              function (obj) {
                return obj.queue_line_id == this.selected_queue.id;
              }.bind(this)
            );
            const ticket =
              queueTickets[queueTickets.length - 1] ||
              tickets[tickets.length - 1];

            if (!this.goToTicket(ticket && ticket.unique_id)) {
              this.danger_modal.active = true;
            } else {
              this.new_ticket = ticket;
            }
          }.bind(this)
        )
        .catch(
          function () {
            this.danger_modal.active = true;
          }.bind(this)
        )
        .finally(
          function () {
            this.queueEnabled = true;
            $("#PreLoader").hide();
          }.bind(this)
        );
    },
    joinQueue() {
      this.queueEnabled = false;
      $("#PreLoader").show();
      let payload = {
        services: this.selected_services
          .map(function (obj) {
            return obj.id + "-qte:" + obj.qte;
          })
          .join(","),
        business_id: this.Vendor.id,
        _method: "PUT"
      };

      queueService
        .createTicket(this.selected_queue.id, payload)
        .then(
          function (data) {
            const uniqueId = this.getTicketUniqueId(data);
            if (this.goToTicket(uniqueId)) {
              return;
            }
            this.redirectFromConfirmedTickets();
          }.bind(this)
        )
        .catch(
          function () {
            $("#PreLoader").hide();
            this.danger_modal.active = true;
            this.queueEnabled = true;
          }.bind(this)
        );
    },
    goBack() {
      // if (this.selected_queue) {
      this.selected_queue = null;
      this.selected_services = [];
      this.queue_services = [];
      // } else {
      this.$emit("goBack");
      // }
    },
    checkQueuesLength() {
      if (this.Vendor.queues.length == 1) {
        this.selected_queue = this.Vendor.queues[0];
      }
    },
  },
};
</script>

<style lang="scss">
#LandingAgency {
  overflow-y: hidden !important;
  .queue {
    box-shadow: 0 0 2px 1px #ddd;
    border-radius: 5px;
    margin-bottom: 20px;
    padding: 15px 20px;
    transition: 0.3s;
    cursor: pointer;
    .left {
      .name {
        font-size: 15px;
        color: #444;
        letter-spacing: 1px;
      }
      .infos {
        display: flex;
        margin-top: 5px;
        .info {
          font-size: 13px;
          color: #666;
          .icon {
            margin-right: 5px;
          }
        }
      }
    }

    .right {
      font-size: 18px;
      color: #666;
      margin-top: 10px;
      .icon {
        transition: 0.3s;
      }
    }
  }
  .queue:hover {
    transform: scale(1.02);
    box-shadow: 0 0 3px 2px #ddd;
  }
  .queue:hover > .right .icon {
    // margin-right: -20px;
  }
  .queue-selected {
    border: 1px solid var(--secondary);
  }
  .services {
    width: 100%;
    margin-left: -15px;
    .search {
      display: flex;
      width: 100%;
      margin-top: 40px;
      margin-bottom: 20px;
      input {
        height: 40px;
        width: 100%;
        border: 1px solid #ddd;
        padding: 0 10px;
        border-radius: 5px 0 0 5px;
      }
      button {
        width: 40px;
        height: 40px;
        border-radius: 0 5px 5px 0;
        background: var(--primary);
        color: var(--primary-font);
        outline: none;
        outline: hidden;
      }
      button:hover {
        background: var(--primary-hover);
      }
    }

    .service {
      margin-top: 10px;
      padding: 0 10px;
      label {
        font-size: 14px;
        letter-spacing: 1px;
        cursor: pointer;
      }
      .checkbox {
        float: right;
        cursor: pointer;
      }
      .vs-checkbox-primary input:checked + .vs-checkbox {
        background: var(--primary);
        outline: 2px solid #fff !important;
        border: none;
        padding-top: 3px;
      }

      .vs-checkbox--check .vs-icon {
        /* color: #054479 !important; */
        font-weight: bold;
      }
    }
  }

  .buttons {
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 0 0;
    transform: translate(-24%, 0);
    .button {
      border: 3px solid var(--primary);
      border-radius: 100px;
      height: 40px;
      transition: 0.3s;
      color: var(--primary);
      background: #fff;
      font-size: 15px;
      width: 230px;
    }
    .button:hover {
      transform: scale(1.02);
    }
    .button-filled {
      background: var(--primary);
      color: var(--primary-font);
    }
  }
}
.buttons {
  position: fixed;
  bottom: 40px;
  transform: translate(-24%, 0);
  background: #fff;
  width: 100%;
  padding: 0 0;
  .button {
    border: 3px solid var(--primary);
    border-radius: 100px;
    height: 40px;
    transition: 0.3s;
    color: var(--primary);
    background: #fff;
    font-size: 15px;
    width: 230px;
    margin: 0px 60px;
    .closedBadge {
      background: var(--danger);
      color: var(--danger-font);
      border-radius: 20px;
      padding: 3px 10px;
      font-size: 10px;
    }
  }
  .button:hover {
    transform: scale(1.02);
  }
  .button-filled {
    background: var(--primary);
    color: var(--primary-font);
  }
}
.yaraab {
  left: 50%;
}
.space-under {
  margin-bottom: 10px;
}

.buttonQte {
  width: 20px;
  height: 22px;
  background-color: var(--primary);
  border-style: none;
  color: white;
  margin: 0 10px;
  font-size: 16px;
}

// checkbox style
.checkbox {
  font-family: sans-serif;
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  letter-spacing: 1px;
  cursor: pointer;
  justify-content: space-between;
  margin: 16px 0;
  padding: 0 5px;
}
.checkbox input {
  display: none;
}
.checkbox input:checked ~ .checkbox__mark svg {
  opacity: 1;
  transform: translate(-50%, -50%) scale(1);
}
.checkbox__mark {
  margin-right: 0.5rem;
  position: relative;
  width: 20px;
  height: 20px;
  border: 2px solid rgb(110, 109, 109);
}
.checkbox__mark svg {
  position: absolute;

  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.5);
  width: 80%;
  height: auto;
  transition: all ease 0.2s;
  opacity: 0;
}
.checkbox--disabled {
  color: grey;
  pointer-events: none;
}
.checkbox--disabled .checkbox__mark {
  border-color: grey;
}
.checkbox--disabled .checkbox__mark {
  border-color: grey;
}
</style>